import { Button, Box, Text } from '@fluentui/react-northstar';
import React, { useEffect, useState } from 'react';
import AuthHelper from '../../helper/auth-helper';
import { msalInstance } from '../../helper/AuthContext';
import { Utilities } from '../../helper/Utility';
import { useUserState } from '../../redux/hooks/authenticationHooks';
import { Constants } from '../../helper/constants';
import TokenHelper from '../../helper/tokenHelper';
import { app } from '@microsoft/teams-js';
import { useHistory } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

export const Login: React.FC<{}> = () => {
    localStorage.setItem("origin", window.location.href);
    var componet = localStorage.getItem("origin")!;
    var isForceLogin: boolean = componet.indexOf('dulead') > -1;
    var isTopLevelWindow: boolean = (window === window.parent) && (window === window.top);
    if ((isTopLevelWindow && !isMobile) || isForceLogin) {
        Utilities.LogInfo("In browser specific code", "Login.tsx -> Login");
        localStorage.setItem("LoginType", "Force");
        localStorage.setItem("Channel", "web");
        if (AuthHelper.IsUserLoggedIn()) {
            AuthHelper.AcquireTokenForResource();
        }
        else {
            msalInstance["browserStorage"].clear();
            msalInstance.loginRedirect();
        }
        return <Text content="Authenticating..." size="large" />
    }
    else {
        localStorage.setItem("Channel", "IFrame");
        localStorage.setItem("LoginType", "SSO");
        Utilities.LogInfo("In IFrame function", "Login.tsx -> Login");
        return <SSOSignIn />
    }
};

export const LoginButton: React.FC<{}> = () => {
    return <Box style={{ 'padding': '8px' }}>
        <Box>
            <Text content="Please Sign In"></Text>
        </Box>
        <Box style={{ 'paddingTop': '8px' }}>
            <Button primary onClick={AuthHelper.Login} >Sign In</Button>
        </Box>
    </Box>
}

export const SignInStart: React.FC<{}> = () => {
    AuthHelper.StartSignIn();
    return <Text content="SignIn Start...." size="large" />
}

export const SignInEnd: React.FC<{}> = () => {
    const localstr = localStorage.getItem("origin")!;
    if (localstr?.indexOf("dulead") > -1) {
        AuthHelper.EndSignIn(false, true, localstr);
    } else {
        AuthHelper.EndSignIn();
    }
    return <Text content="Sign-In End" size="large" />
}

/**
 * SSO Sign in for TeamsTab
 * @returns
 */
export const SSOSignIn: React.FC<{}> = () => {

    const [isLoginSuccess, setIsLoginSuccess] = useState<boolean>(true);
    const [user, setUser] = useUserState(); //eslint-disable-line @typescript-eslint/no-unused-vars

    Utilities.LogInfo("In SSOSignIn function", "Login.tsx -> SSOSignIn");
    const history = useHistory ();
    useEffect(() => {
        /**
         * Stores the acquired token, hydrates the user state and notifies the Teams host.
         */
        const completeSignIn = (token: string) => {
            localStorage.setItem("LoginType", "SSO");
            localStorage.setItem(Constants.AccessTokenKey, token);
            const objUser = TokenHelper.DecodeToken();
            setUser({
                accessToken: token,
                enterpriseId: objUser?.enterpriseId!,
                candidateEnterpriseId: objUser?.enterpriseId!,
                firstName: objUser?.firstName!,
                isAuthenticated: true,
                CorrelationId: objUser?.CorrelationId,
                careerLevel: objUser?.careerLevel,
                companyCode: objUser?.companyCode,
                IsAIGUser: Utilities.IsAIGUser(objUser?.companyCode),
                jobTitle: objUser?.jobTitle,
                personnelNumber: objUser?.personnelNumber,
                location: objUser?.location
            });
            app.notifySuccess();
            setIsLoginSuccess(true);
            Utilities.LogInfo("In SSOSignIn successCallback", "Login.tsx -> SSOSignIn");
            const currentPath = window.location.pathname + window.location.search;
            history?.push(currentPath);
        };
        AuthHelper.GetTeamsContext().then(async (user) => {
            let token: string | undefined;
            try {
                await msalInstance.ssoSilent(user!);
                localStorage.setItem("LoginType", "SSO");
                token = await AuthHelper.getRedirectToken(false); //gets token for api
            } catch (error) {
                // ssoSilent cannot work inside the Teams mobile webview (no AAD session in the
                // hidden iframe -> AADSTS50058), so no token is available from MSAL here.
                Utilities.LogError(String(error), "Login.tsx -> SSOSignIn ssoSilent");
            }

            // Fall back to asking the Teams host for the token (works on mobile).
            if (!token) {
                token = (await AuthHelper.TryGetTeamsSsoToken()) ?? undefined;
            }

            if (token) {
                completeSignIn(token);
                return;
            }
            app.notifyFailure({
                reason: app.FailedReason.AuthFailed,
                message: "Unable to acquire an access token for the signed-in user."
            });
            setIsLoginSuccess(false);
        }).catch(error => {
            Utilities.LogError(error, "Login.tsx -> GetTeamsContext SSOSignIn");
            setIsLoginSuccess(false);
        });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return <>{isLoginSuccess ? <h1>SSO SignIn in progress</h1> :
        <LoginButton />}
    </>
}